import React from 'react';
import './Cali.css'; 

const Yopal = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKYP.pdf" target="_blank" rel="noreferrer">Aeropuerto El yopal</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 05</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/DEVA1A.pdf" target="_blank" rel="noreferrer">DEVA1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/OSIL1L.pdf" target="_blank" rel="noreferrer">OSIL1L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/OSIL1L.pdf" target="_blank" rel="noreferrer">REMI1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/OSIL1L.pdf" target="_blank" rel="noreferrer">TOBS1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/OSIL1L.pdf" target="_blank" rel="noreferrer">VUGE1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/SUPN2A.pdf" target="_blank" rel="noreferrer">SUPN2A</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/KOTM1C.pdf" target="_blank" rel="noreferrer">KOTM1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/KOTM1C.pdf" target="_blank" rel="noreferrer">SIRU1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/KOTM1C.pdf" target="_blank" rel="noreferrer">TITN1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/KOTM1C.pdf" target="_blank" rel="noreferrer">UBNO1H</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/BUTI2B.pdf" target="_blank" rel="noreferrer">BUTI2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">ANGU1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">BUTI1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">KOTM1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">OSIL1K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">REMI1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">TITN1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">TOBS1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">UBNO1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1D.pdf" target="_blank" rel="noreferrer">VUGE1D</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">ANGU1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">BUTI1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">KOTM1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">OSIL1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">REMI1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">TITN1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">TOBS1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">UBNO1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ANGU1C.pdf" target="_blank" rel="noreferrer">VUGE1C</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ILSY05.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/ILSZ05.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/VORY05.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/VORZ05.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/RNP05.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 23</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKYP/RNP23.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Yopal;